import styled from 'styled-components';

export const Container = styled.form`
  > div {
    height: 50px;
    background-color: #eef0f1;

    > input {
      background-color: #eef0f1;

      height: 55px;

      font-size: 1rem;
    }
  }

  > button {
    font-family: 'Montserrat';
    font-size: 1.4rem;
    background-color: var(--purple84);
  }

  @media (max-width: 560px) {
    width: 100%;

    > div {
      width: 100%;
    }

    > button {
      width: 100%;
    }
  }
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
`;
